<template>
  <div class="login-page-container">
    <div class="bg">
      <div class="auth-box-w">
        <div class="logo-w">
          <img alt :src="require('../../assets/' + app.logo_main)" />
        </div>
        <h4 class="auth-header">设置新密码</h4>
        <form @submit.prevent="handleNewPassword">
          <div class="form-group">
            <label for>新密码</label>
            <input
              v-model="new_password"
              class="form-control"
              placeholder="请输入新密码"
              type="password"
            />
            <div class="pre-icon os-icon os-icon-fingerprint"></div>
          </div>
          <div class="form-group">
            <label for>确认密码</label>
            <input
              v-model="repeat_password"
              class="form-control"
              placeholder="请确认密码"
              type="password"
            />
          </div>
          <div class="buttons-w">
            <button :disabled="submiting" class="btn btn-primary">确 认</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { passwdLoginPost, getCaptcha } from '@/service/getData'
import store from '../../store/store'
import { host, app } from '@/config/env'

import { updateUser, userSet } from '../../service/getData'

const allLetters = 'abcdefghijklmnopqrstuvwxyz'

export default {
  data() {
    return {
      app,
      submiting: false,
      new_password: null,
      repeat_password: null,
      old_password: '88888888',
    }
  },
  created() {},
  methods: {
    async handleNewPassword() {
      var passwordreg =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,16}/

      let password = this.new_password.toLowerCase()
      // 密码3位比对
      for (let i = 0; i < password.length - 2; i++) {
        let n1 = password[i]
        let n2 = password[i + 1]
        let n3 = password[i + 2]
        // 判断重复字符
        if (n1 === n2 && n1 === n3) {
          this.$message.error('密码不能包含连续3位重复的字符')
          return
        } else if (allLetters.includes(n1 + n2 + n3)) {
          this.$message.error('密码不能包含连续3位正序排列的字母字符')
          return
        }
      }

      if (!passwordreg.test(this.new_password)) {
        this.$message.error(
          '密码必须包含大小字母、数字和特殊符号，且长度为8到16位！'
        )
        return
      }

      if (this.new_password != this.repeat_password) {
        this.$message.error('两次输入密码不一致')
        return
      }
      this.submiting = true
      let userInfo = store.state.userInfo
      let data = {
        id: userInfo.id,
        new_password: this.new_password,
        repeat_password: this.repeat_password,
        old_password: this.old_password,
      }

      let res = await userSet(data)
      if (res.code == 0) {
        if (store.state.loginRedirect) {
          this.$router.push(store.state.loginRedirect)
        } else {
          this.$router.push('/dashboard')
        }
      }
      this.submiting = false
    },
  },
}
</script>

<style scoped>
.login-page-container {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
}

.login-page-container .bg {
  margin-top: 40px;
  /* background-image: url(../../assets/bg-pattern2.png);
  background-size: contain;
  background-repeat: repeat;
  background-position: 0 0; */
}
.login-page-container:before {
  content: '';
  position: absolute;
  z-index: -1;
  background-color: #f2f4f7;
  /* background: -webkit-gradient(
    linear,
    left top,
    right bottom,
    from(#ffffff),
    to(#3082f8)
  );
  background: linear-gradient(to bottom right, #ffffff, #3082f8); */
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
}
.captcha {
  display: flex;
}
.captcha img {
  width: 38%;
  height: intrinsic;
  margin-left: 8%;
  margin-right: 4%;
}
.logo-w h2 {
  letter-spacing: 2px;
  font-weight: bold;
}
label {
  margin-bottom: 4px;
}
</style>